var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail-button"},[_c('van-button',{attrs:{"type":"info","block":""},on:{"click":_vm.clickHandler}},[_vm._t("default",function(){return [_vm._v("点击开始拖车")]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }